﻿import { Box, Drawer, IconButton, Theme, List, Divider, ListItemButton, ListItemText, styled, Toolbar, AppBar, Button, MenuItem, Menu, useTheme, useMediaQuery } from "@mui/material"
import {faBars, faChevronUp, faRightFromBracket} from '@fortawesome/pro-solid-svg-icons'; 
import React from "react";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { AdminRoutes } from "../../constants/routes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Logo from '../../assets/img/bctlogo.png';
import { useAuthenticatedUser } from '@/hooks/useAuthenticatedUser';
import * as Dtos from '../../api/dtos';
import * as Constants from '../../constants/routes'
import { faGear, faUser, faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { useScopedField } from "@ngt/forms-core";
import { ASMHomePage } from "@/constants/constants";

const Anchor = styled('a')({})

interface MenuLinkProps {
    path: string,
    text: string,
    external?: boolean,
}

interface MobileMenuLinkProps {
    path: string,
    text: string,
    toggleDrawer: (open: boolean) => void,
}

const MobileMenuLink: React.FunctionComponent<MobileMenuLinkProps> = ({ path, text, toggleDrawer }) => {
    const location = useLocation();

    return (
        <>
            {
                path === AdminRoutes.LOGOUT ?
                    <ListItemButton
                        component="a"
                        href={path!}
                        onClick={() => toggleDrawer(false)}
                        sx={{
                            backgroundColor: location?.pathname === path ? '#502d77' : 'white',
                            color: location?.pathname === path ? 'white' : 'black',
                            '&:hover': {
                                backgroundColor: '#502d77',
                                color: 'white'
                            }
                        }}
                    >
                        <ListItemText primary={text} />
                    </ListItemButton> :
                    <ListItemButton
                        component={Link}
                        to={path!}
                        onClick={() => toggleDrawer(false)}
                        sx={{
                            backgroundColor: location?.pathname === path ? '#502d77' : 'white',
                            color: location?.pathname === path ? 'white' : 'black',
                            '&:hover': {
                                backgroundColor: '#502d77',
                                color: 'white'
                            }
                        }}
                    >
                        <ListItemText primary={text} />
                    </ListItemButton>
            }
        </>
    )
}

const MenuLink: React.FunctionComponent<MenuLinkProps> = ({ path, text }) => {

    return (
        <Box>
            {
                path === AdminRoutes.LOGOUT ?
                    <Anchor href={path} style={{ textDecoration: 'none' }}>
                        <Box
                            sx={{
                                color: '#EC008C',
                                border: 'solid 2px',
                                borderColor: '#EC008C',
                                borderRadius: '4px',
                                '&:hover': {
                                   borderColor: '#EC008C',
                                   color: '#EC008C',
                                },
                                py: 1,
                                px: 2,
                                mx: 2
                            }}
                        >
                            {text}
                        </Box>
                    </Anchor> :
                    <Anchor href={path} style={{ textDecoration: 'none' }}>
                        <Button
                            color="tertiary"
                            sx={{
                                // backgroundColor: "#76CED9",
                                // color: 'white',
                                // borderColor: 'secondary',
                                // borderRadius: '4px',
                                // fontWeight: 'bold',
                                // fontFamily: 'GTPressura',
                                // padding: 2 * 5,
                                // minWidth: 120,
                                // textTransform: 'none',
                                // fontSize: '1.125rem',
                                py: 1,
                                px: 2,
                                mx: 2,
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {text}
                        </Button>
                    </Anchor>
            }
        </Box>
    )
}

const RegistrationNavigation: React.FunctionComponent = () => {
    const {state: {value: cost}, context: {setValue: setCost}} = useScopedField<number>("cost", {value: true});
    
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };

    const authUser = useAuthenticatedUser<Dtos.UserDto>();
    return (
        <Box>
            <Box
                sx={{
                    ...theme.mixins.toolbar
                }}
            >

            </Box>
            <AppBar color="inherit" position="fixed" style={{width: '100%', backgroundColor: 'common.white'}}>
                <Toolbar>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: '100%'
                    }}>

                        <Box sx={{
                            mt:'10px',
                            mb: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            width: {
                                xs: '100px',
                                md: '120px',
                                lg: '150px'
                            },
                            '& img': {
                                width: '100%'
                            }
                        }}>
                            <a href={ASMHomePage}><img src={Logo} alt="Logo for the breast cancer trials."/></a>
                        </Box>
                        {
                            <>
                                <Box
                                    className="desktopDiv"
                                >
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            height: '100%',

                                        }}
                                    >
                                        {
                                            authUser ?
                                                <Box>
                                                    <Box
                                                        color={open ? '#EC008C' : '#502d77'}
                                                        sx={{
                                                            '&:hover': {
                                                                borderColor: '#EC008C',
                                                                color: '#EC008C',
                                                            },
                                                            cursor: 'pointer',
                                                            whiteSpace: 'nowrap'
                                                        }}
                                                        onClick={handleClick}
                                                    >
                                                        <FontAwesomeIcon icon={faUser} style={{"paddingRight":"5px", "paddingLeft":"20px"}}/>
                                                        {isMobile ? authUser.firstName : authUser.displayName }
                                                        <IconButton
                                                            onClick={handleClick}
                                                            aria-controls={open ? 'account-menu' : undefined}
                                                            aria-haspopup="true"
                                                            aria-expanded={open ? 'true' : undefined}
                                                        >
                                                            <FontAwesomeIcon icon={open ? faChevronUp : faChevronDown} size="sm"/>
                                                        </IconButton>
                                                    </Box>
                                                    <Menu
                                                        anchorEl={anchorEl}
                                                        id="account-menu"
                                                        open={open}
                                                        onClose={handleClose}
                                                        onClick={handleClose}
                                                        MenuListProps={{
                                                            disablePadding: true
                                                        }}
                                                        PaperProps={{
                                                            elevation: 0,
                                                            sx: {
                                                                overflow: 'visible',
                                                                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                                                mt: 1.5,

                                                                '& .MuiAvatar-root': {
                                                                    width: 32,
                                                                    height: 32,
                                                                    ml: -0.5,
                                                                    mr: 1,
                                                                },

                                                                '&:before': {
                                                                    content: '""',
                                                                    display: 'block',
                                                                    position: 'absolute',
                                                                    top: 0,
                                                                    right: 14,
                                                                    width: 10,
                                                                    height: 10,
                                                                    bgcolor: 'background.paper',
                                                                    transform: 'translateY(-50%) rotate(45deg)',
                                                                    zIndex: 0,
                                                                },
                                                            },
                                                        }}
                                                        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                                        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                                                    >
                                                        {
                                                            authUser?.isAdmin ? 
                                                                [
                                                                <Anchor key="admin-link" href={Constants.AdminRoutes.ADMIN_BASE} style={{ textDecoration: 'none', color: 'black' }}>
                                                                    <MenuItem>
                                                                        <FontAwesomeIcon icon={faGear} size="sm" style={{"paddingRight":"5px"}}/>
                                                                            Admin Panel
                                                                    </MenuItem>
                                                                </Anchor>,
                                                                <Divider key="divider" />
                                                                ] :
                                                                null
                                                        }
                                                        <Anchor href={Constants.AdminRoutes.LOGOUT} style={{ textDecoration: 'none', color: 'black' }}>
                                                        <MenuItem>
                                                        <FontAwesomeIcon icon={faRightFromBracket} size="sm" style={{"paddingRight":"5px"}}/>
                                                            Logout
                                                        </MenuItem>
                                                        </Anchor>
                                                    </Menu>
                                                </Box> :
                                                <MenuLink
                                                    path={"/auth/openiddict"}
                                                    text="Members Login"
                                                />
                                        }
                                        <Box>
                                            <Box
                                                sx={{
                                                    color: "white",
                                                    border: 1,
                                                    borderRadius: 2,
                                                    borderColor: "#502d77",
                                                    backgroundColor: '#502d77',
                                                    fontWeight: 'bold',
                                                    fontFamily: 'GTPressura',
                                                    padding: 2 * 5,
                                                    minWidth: 120,
                                                    textTransform: 'none',
                                                    fontSize: '1.125rem',
                                                    py: 1,
                                                    px: 2,
                                                    mx: 2,
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Total: ${cost ? cost : 0}
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            </>
                        }
                        </Box>
                </Toolbar>
            </AppBar>
        </Box>
)
}

export default RegistrationNavigation;